import React from 'react';
import PropTypes from 'prop-types';
import PublicHeader from './PublicHeader';
import './PublicLayout.scss';

const PublicLayout = ({ children }) => {
  return (
    <div className="public-layout">
      {/* Header fijo con navegación inteligente */}
      <PublicHeader />
      <main className="public-content">
        {children}
      </main>
    </div>
  );
};

PublicLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default PublicLayout;